module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Um85DG/tc-custom/9781528958806.jpg?1709061671941",
      "alt": "This image is the cover for the book Meat on a Stick"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Meat on a Stick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Assassinations, recriminations, a near-death experience with a suicidal flying examiner, love at first sight, a ghost or two, or three, a famous half-sister, visiting heaven and hell, inventing the hydrofoil and getting caned for it, a naked plumber, a TV wrestler’s trouble in the bedroom, cleaning out a casino and then throwing it all away, helping John Major fight the Kuwait oil fire, dowsing for dead people, patents and planning decisions, lies, truths and uncertainties. Following a fairly serious motor accident in 2005 which damaged a disc in my neck, I had then, along with the pain of a trapped nerve which kept me awake at night, the luxury of time that I never previously enjoyed to reassess some of the more curious things that have happened to me during my time on this earth. Some of these things are only now beginning to make sense to me. Others perhaps never will. Taken as a whole, all of them lead me inexorably to believe that mankind is far greater than the simple reflection we see of ourselves in the mirror.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Emin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The author was born in Cyprus in 1944 to a happy but somewhat-unconventional family. John came to England in 1948 and was educated in London. He has been very happily married to Barbara since 1969, having run a business with his wife. John has three children, two boys and one girl, and a football team of grandchildren.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0